module.exports = __webpack_public_path__ + "img/op33.31509b48.png";